<template>
    <v-container fluid>
        <ReadHeader :current="current" />

        <v-row>
            <v-col>
                <KeyValue
                :title="`Phone`"
                :value="entityCore.phone"
                ></KeyValue>
            </v-col>
            <v-col>
                <KeyValue
                :title="`Subcontractor DIR Number`"
                :value="entityCore.dir_project_identifier"
                ></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue
                :title="`Address`"
                :value="entityCore.address_line_1"
                ></KeyValue>
            </v-col>
            <v-col>
                <KeyValue
                :title="`Address Continued`"
                :value="entityCore.address_line_2"
                ></KeyValue>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col>
                <KeyValue
                :title="`City`"
                :value="entityCore.city"
                ></KeyValue>
            </v-col>
            <v-col cols="3">
                <KeyValue
                :title="`State`"
                :value="entityCore.state"
                ></KeyValue>
            </v-col>
            <v-col cols="3">
                <KeyValue
                :title="`Zip`"
                :value="entityCore.zip"
                ></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue
                :title="`Email`"
                :value="entityCore.email"
                ></KeyValue>
            </v-col>
            <v-col>
                <KeyValue
                :title="`License`"
                :value="entityCore.license"
                ></KeyValue>
            </v-col>
        </v-row>

        <v-row v-if="entityCore.social_program_identifiers">
            <v-col>
                <h3>Social Program Identifiers</h3>
                <v-list lines="one">
                    <v-list-item
                        v-for="program in entityCore.social_program_identifiers"
                        :key="program"
                        :title="jsonValueToTitle(socialProgramIdentifiers, program)"
                        density="compact"
                    ></v-list-item>
                </v-list>
            </v-col>
        </v-row>

    </v-container>
</template>
<script setup>
import { useRoute } from 'vue-router';
import { useEntityCore, useJsonValueToTitle } from "@/assets/modules/composables.js";
import socialProgramIdentifiers from "@/assets/selects/socialProgramIdentifiers.json";
import ReadHeader from "@/components/interface/ReadHeader.vue";
import KeyValue from "@/components/interface/Key-Value.vue";
const route = useRoute();

const { entityCore } = useEntityCore();
const { jsonValueToTitle } = useJsonValueToTitle();
const current = {
    type: "subcontractor",
    id: route.params.entity_id,
};
</script>